import '@abraham/reflection';

import { getBoostTAE } from '@boost/widget-integration-tae/lib';
import { bootstrap, setupGlobalExtensions } from 'framework/core';

import { AppModule } from './modules/app/app.module';
import { warmupWorkers } from './workers/workers-provider';

async function main() {
  warmupWorkers();
  setupGlobalExtensions();

  const TAEApp = getBoostTAE();

  TAEApp.onReady(async () => {
    // Wait for customized script to be loaded
    await (TAEApp.getModuleByName('AssetFilesLoader') as any).assetLoadingPromise(
      'customizedScript'
    );

    await window.boostWidgetIntegration.onBeforeAppBootstrap?.();
    const app = await bootstrap(AppModule);

    window.boostWidgetIntegration.App = app;
  });
}

main();
